var _defs, _polygon, _path, _path2, _path3, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _text11, _text12, _text13, _text14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 295.2 295.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: .02em;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #f37470;\n      }\n\n      .cls-3 {\n        font-size: 18.96px;\n      }\n\n      .cls-3, .cls-4 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .cls-6 {\n        letter-spacing: .02em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        letter-spacing: .03em;\n      }\n\n      .cls-4 {\n        font-size: 21.1px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "248.54 219.53 44.75 207.62 44.75 77.59 264.53 110.55 248.54 219.53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.27,129.32c-2.35-1.48-5.18-2.23-8.49-2.23h-8.49v35.48h8.49c3.36,0,6.21-.77,8.53-2.31,2.32-1.54,4.1-3.67,5.34-6.39,1.23-2.72,1.85-5.76,1.85-9.12s-.62-6.54-1.85-9.21c-1.23-2.66-3.03-4.74-5.38-6.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.58,129.32c-2.35-1.48-5.18-2.23-8.49-2.23h-8.49v35.48h8.49c3.36,0,6.21-.77,8.53-2.31,2.32-1.54,4.1-3.67,5.34-6.39,1.23-2.72,1.85-5.76,1.85-9.12s-.62-6.54-1.85-9.21c-1.23-2.66-3.03-4.74-5.38-6.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.53,4.11C68.01,4.11,3.53,68.58,3.53,148.11s64.47,144,144,144,144-64.47,144-144S227.06,4.11,147.53,4.11ZM98.15,160.55c-2.47,4.48-5.93,7.96-10.38,10.42-4.46,2.47-9.68,3.7-15.68,3.7h-22.28v-59.69h22.28c6.56,0,12.03,1.33,16.43,3.99,4.4,2.66,7.72,6.25,9.96,10.76,2.24,4.51,3.36,9.51,3.36,15.01,0,6.05-1.23,11.32-3.7,15.8ZM168.01,174.68h-11.94l-9.67-23.37-9.58,23.37h-12.02l-23.2-59.69h14.96l15.05,43.71,5.88-15.89-10-27.74h12.69l6.22,19.08,6.22-19.08h12.78l-10.17,27.74,6.05,15.89,14.96-43.71h15.05l-23.29,59.69ZM244.84,160.55c-2.47,4.48-5.93,7.96-10.38,10.42-4.46,2.47-9.68,3.7-15.68,3.7h-22.28v-59.69h22.28c6.56,0,12.03,1.33,16.43,3.99,4.4,2.66,7.72,6.25,9.96,10.76,2.24,4.51,3.36,9.51,3.36,15.01,0,6.05-1.23,11.32-3.7,15.8Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(48.51 201.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "DIA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 42.09,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 57.91,
    y: 0
  }, "Y "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 79.2,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 103.95,
    y: 0
  }, "ITH "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 149.04,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 166.78,
    y: 0
  }, "AD"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(43.17 233.42) rotate(48.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(53.88 245.05) rotate(41.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(66.59 255.85) rotate(34.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(79.73 264.43) rotate(29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(88.4 269.28) rotate(22.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(107.22 276.68) rotate(14.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(125.14 280.92) rotate(6.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(142.16 282.62) rotate(-.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(158.69 282.15) rotate(-5.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(168.56 281.17) rotate(-12.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(188.68 276.25) rotate(-20.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(204.05 270.1) rotate(-26.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(212.84 265.74) rotate(-31.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(227.04 256.71) rotate(-39.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(242.05 243.95) rotate(-47.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.443293df1ef43b65177677ed48a83c89.svg";
export { ForwardRef as ReactComponent };